import P from '../../pages';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import ReactOnRails from 'react-on-rails';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import Button from 'react-bootstrap/lib/Button';
import Modal from 'react-bootstrap/lib/Modal';
import ButtonGroup from './ButtonGroup';
import PhotoForm from './PhotoForm';
import ReactMarkdown from 'react-markdown';
import Camera from 'react-icons/lib/fa/camera';
import Alert from './Alert';
import PhotoTable from './PhotoTable';
import { get } from 'lodash';

class Photo extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      page: this.props.page,
      photos: this.props.photos
    };
    this.handleEditPhoto = this.handleEditPhoto.bind(this);
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.isPhotoRequired = this.isPhotoRequired.bind(this);
    this.handleNewPhoto = this.handleNewPhoto.bind(this);
    this.handleDestroyPhoto = this.handleDestroyPhoto.bind(this);
    this.pageValid = this.pageValid.bind(this);
  }

  getInitialState() {
    return {
      showModal: false,
      editing: false,
      destroy: false
    };
  }

  handleNewPhoto() {
    this.setState({
      showModal: true,
      editing: true,
      activePhoto: {
        name: '',
        kind: '',
        image: {
          thumbnail: '',
          small: '',
          medium: '',
          original: ''
        },
      }
    });
  }

  handleEditPhoto(e, payload) {
    e.preventDefault();
    this.setState({
      showModal: true,
      editing: true,
      activePhoto: payload
    });
  }

  handleDestroyPhoto(e, payload) {
    e.preventDefault();
    this.props.onPhotoDestroySubmit({
      method: 'DELETE',
      form: {
        host_id: this.props.user.host.id,
        resident_id: get(this.props, 'resident.id', ''),
        room_id: get(this.props, 'room.id', ''),
        authenticity_token: ReactOnRails.authenticityToken(),
        photo: {
          id: payload.id
        }
      }
    });
  }

  componentWillMount() {
    this.props.onFetchPhotosIfNeeded();
  }

  componentWillReceiveProps(newProps){
    if (this.state.photos != newProps.photos){
      this.setState({photos: newProps.photos})
    }
  }

  pageValid(){
    let kinds = this.state.photos.items.map(p => p.kind)
    let expectedKinds = this.props.market.required_host_photo_kinds.map(k => k[1])
    return expectedKinds.every(i => kinds.includes(i))
  }

  back(e) {
    e.preventDefault();
    this.props.onGoBack();
  }

  submit(e) {
    this.props.onPhotoSubmit();
  }

  close() {
    this.setState({ showModal: false });
  }

  open() {
    this.setState({ showModal: true });
  }

  isPhotoRequired(k) {
    return this.props.market.required_host_photo_kinds.find(p => p[1] === k[1])
  }

  render() {
    const thisPage = P.PHOTO_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;
    const { isFetching, lastUpdated, didInvalidate } = this.state.photos;
    const {editing, activePhoto, formAction} = this.state;
    const photos = this.state.photos.items
    const requiredPhotos = this.props.market.required_host_photo_kinds

    return (
      <div id={page} className='profile'>

        <Redirector this_page={thisPage} page={page}/>

        <form>
          <FormHeader title={content.pages.photo.title} icon={<Camera />}/>
          <ReactMarkdown source={content.pages.photo.body}/>
            <div className='row'>
              <div className='col-md-3'>
                <Button
                  onClick={this.handleNewPhoto}
                  id='add-btn'>
                  {formatMessage(defaultMessages.clientHostPagesPhotoActionsCreate)}
                </Button>
              </div>
              <div className='col-md-9'>
                <div className='row'>
                  {
                    this.props.market.host_photo_kinds.map(k => {
                      const required = this.isPhotoRequired(k)
                      const exists = photos.find(p => p.kind === k[1])
                      return (
                        <div className='col-md-6' key={k}>
                          {k[0]} {exists && <i className={`fa fa-check-circle text-success`} /> }&nbsp;
                          {required && <i className={`fa fa-asterisk text-${exists ? 'success'  :'danger'}`} />}
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </div>

          <PhotoTable
            photos={photos}
            editFunc={this.handleEditPhoto}
            destroyFunc={this.handleDestroyPhoto}
            didInvalidate={didInvalidate} />

          <Alert alert={content.pages.photo.info} />

          <ButtonGroup
            page={thisPage}
            backFunc={this.back}
            submitFunc={this.submit}
            disableSubmit={!this.pageValid()}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl} />

        </form>

        <Modal show={this.state.showModal} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>{activePhoto && activePhoto.id ?
              formatMessage(defaultMessages.clientHostPagesPhotoActionsUpdate) :
                formatMessage(defaultMessages.clientHostPagesPhotoActionsCreate)
            }</Modal.Title>
          </Modal.Header>
          <Modal.Body>

           <PhotoForm
            intl={this.props.intl}
            photo={activePhoto}
            user={this.props.user}
            onPhotoFormSubmit={this.props.onPhotoFormSubmit}
            didInvalidate={didInvalidate}
            onClose={this.close}
            uploader={this.props.uploader}
            photoKinds={this.props.market.host_photo_kinds}/>

          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

Photo.propTypes = {
   onPhotoDestroySubmit: PropTypes.func,
   onPhotosRefresh: PropTypes.func,
   onPhotoSubmit: PropTypes.func,
   onSkipSubmit: PropTypes.func,
   onGoBack: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object,
   photos: PropTypes.object
};

export default injectIntl(Photo);
